import {Button, Form, message, Space, Spin} from 'antd';
import styles from './index.module.scss';
import {LinkButton} from 'Features/Buttons/LinkButton';
import {ReloadOutlined} from '@ant-design/icons';
import useRequest from 'Utils/Hooks/useRequest';
import {changePubKeyStatus, getPubPwdKey, refreshPubPwdKey} from '../service';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {errorMessage, isTrue} from 'Utils/common';
import Copy from 'copy-to-clipboard';
import {Auth} from 'Features/Auth';
import {SimpleSwitch} from 'Features/Fields/SimpleSwitch';
import {Status} from 'Services/common';

export function DynamicLogin() {
    const [data, {loading}, refresh] = useRequest(getPubPwdKey);

    const [refreshPwd, refreshPwdStatus] = useRequestFn(async () => {
        try {
            await refreshPubPwdKey();
            refresh();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const [changeStatus, status] = useRequestFn(async (status: Status) => {
        try {
            await changePubKeyStatus(status);
            await refresh();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    function onCopy() {
        if (!data) return;
        Copy(data.pwd);
        message.success('复制成功');
    }

    return (
        <div className={styles.root}>
            <Spin spinning={loading}>
                <Form>
                    <Auth code="SF_GRglhO4j041">
                        <Form.Item label="动态凭证" wrapperCol={{offset: 1}}>
                            <SimpleSwitch
                                value={data?.status}
                                loading={status.loading}
                                onChange={changeStatus}
                            />
                        </Form.Item>
                    </Auth>

                    <div className={styles.fields}>
                        <div className={styles.header}>
                            <Space size={20} hidden={!isTrue(data?.status)}>
                                <Auth code="SF_GRglhO4j032">
                                    <LinkButton onClick={onCopy}>
                                        复制动态凭证码
                                    </LinkButton>
                                </Auth>

                                <Auth code="SF_GRglhO4j043">
                                    <Button
                                        type="primary"
                                        icon={<ReloadOutlined />}
                                        onClick={refreshPwd}
                                        loading={refreshPwdStatus.loading}>
                                        刷新动态凭证
                                    </Button>
                                </Auth>
                            </Space>
                        </div>

                        <Space className={styles.code}>
                            {(data?.pwd || '').split('')}
                        </Space>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}
